import { render, staticRenderFns } from "./MirrorCard.vue?vue&type=template&id=70614c64&scoped=true&"
import script from "./MirrorCard.vue?vue&type=script&lang=js&"
export * from "./MirrorCard.vue?vue&type=script&lang=js&"
import style0 from "./MirrorCard.vue?vue&type=style&index=0&id=70614c64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70614c64",
  null
  
)

export default component.exports